import { FC, ReactElement } from "react";

export const page = (arg: { url: string; component: FC<any> }) => {
  return arg;
};
